import React, { useState } from "react";
import AdminSidebar from "../AdminSidebar/AdminSidebar";
import AdminHeader from "../AdminHeader/AdminHeader";
import { Outlet } from "react-router-dom";

const AdminDashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50 theme-app-shell overflow-x-clip">
      {/* Sidebar */}
      <AdminSidebar
        isMobileOpen={isSidebarOpen}
        onCloseMobile={() => setIsSidebarOpen(false)}
      />

      {/* Main Section */}
      <div className="flex-1 flex min-w-0 flex-col lg:pl-20">
        {/* Header */}
        <AdminHeader onMenuToggle={() => setIsSidebarOpen((open) => !open)} />

        {/* Main content area */}
        <main className="flex-1 overflow-y-auto px-4 pb-6 pt-4 sm:px-5 lg:px-6 theme-main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminDashboardLayout;
